import moment from 'moment-timezone';

var hourly_rate = ''
var width = window.screen.width
if (width > 1000) {
    width = width - 200
}

function additionalItems(items) {
    return items.map(item => {
        return `
        <tr class="item">
                <td style='text-align: left;max-width: 50px'>
                    ${item['quantity']}
                </td>
                <td style='text-align: left;max-width: ${width / 3}px'>
                    <div>
                    ${item['description']}
                    </div>
                </td>
                <td style='text-align: right'>
                    R ${parseFloat(item['amount']).toFixed(2)}
                </td>
                <td style='text-align: right'>
                    R ${parseFloat(item['amount'] * item['quantity']).toFixed(2)}
                </td>
            </tr>
        `
    })
}

const total = (invoice) => {
    var amount = parseFloat(invoice['amount'])
    if (invoice['invoice_items']) {
        invoice['invoice_items'].forEach(item => {
            const sum = parseFloat(parseFloat(item['amount']) * parseInt(item['quantity'], 10))
            amount = parseFloat(amount) + sum
        })
    }

    if (invoice['no_of_hours']) {
        var hours = invoice['no_of_hours'].split(':')[0];
        var minutes = invoice['no_of_hours'].split(':')[1];

        if (hours >= 1) {
            amount += hours * 360
        }
        if (minutes >= 1 && minutes <= 30) {
            amount += 180
        }
        if (minutes > 30) {
            amount += 360
        }
    }
    return amount
}

const calculate = (invoice) => {
    var amount = 0
    if (invoice['no_of_hours']) {
        var hours = invoice['no_of_hours'].split(':')[0];
        var minutes = invoice['no_of_hours'].split(':')[1];
        if (hours >= 1) {
            amount += hours * 360
        }
        if (minutes > 0 && minutes <= 30) {
            amount += 180
        }
        if (minutes > 30) {
            amount += 360
        }
    }
    return amount
}

const invoice = (data, settings = {}) => {
    const notes = data['notes'] || {}
    const customer = data['customer'] || {}
    const rate = data['rate'] || {}
    console.log('*****data',data)

    return (
        `
<html>

<head>
    <meta charset="utf-8">
    <link key='font' href='https://fonts.googleapis.com/css?family=Poppins:100,200,300,400,600,600,700,800' rel='stylesheet' />
    <style>
        table {
            color: #323539;
            font-family: "Poppins", sans-serif;
        }
        .invoice-box {
            max-width: 800px;
            min-width: 600px;
            margin: auto;
            padding: 30px;
            border: 1px solid #eee;
            background: white;
            box-shadow: 0 0 10px rgba(0, 0, 0, .15);
            font-size: 14px;
            line-height: 24px;
            font-family: 'Helvetica Neue', 'Helvetica', Helvetica, Arial, sans-serif;
            color: #FFFFFF !important;
        }

        #text {
            display: none;
        }

        .invoice-box table {
            width: 100%;
            line-height: inherit;
            text-align: left;
        }

        .invoice-box table td {
            padding: 5px;
            vertical-align: top;
        }

        .invoice-box table tr td:nth-child(2) {
            text-align: right;
        }

        .invoice-box table tr.top table td {
            padding-bottom: 20px;
            color: #323539 !important;
        }

        .invoice-box table tr.top table td.title {
            font-size: 45px;
            line-height: 45px;
            color: #323539 !important;
        }

        .invoice-box table tr.top table td.total {
            font-size: 45px;
            line-height: 45px;
            color: #323539 !important;
        }

        .invoice-box table tr.information table td {
            padding-bottom: 20px;
            color: #323539 !important;
        }

        .invoice-box table tr.customer table td {
            padding-bottom: 10px;
            padding-top: 10px;
            padding-left: 10px;
            font-weight: 600;
            background-color: #EEF3F6;
            color: #323539 !important;
        }

        .invoice-box table tr.payment table td {
            padding-bottom: 20px;
            padding-top: 0px;
        }

        .invoice-box table tr.heading td {
            background: #EEF3F6;
            border-bottom: 1px solid #ddd;
            font-weight: 600;
            color: #323539 !important;
        }

        .invoice-box table tr.details td {
            padding-bottom: 20px;
            color: #323539 !important;
        }

        .invoice-box table tr.item td {
            border-bottom: 1px solid #eee;
            color: #323539 !important;
        }

        .invoice-box table tr.item.last td {
            border-bottom: none;
            color: #323539 !important;
        }

        .invoice-box table tr.total td:nth-child(2) {
            border-top: 2px solid #eee;
            font-weight: 600;
            color: #323539 !important;
        }
    .section {
      margin-bottom: 30px;
    }
        @media only screen and (max-width: 600px) {
            .invoice-box table tr.top table td {
                width: 100%;
                display: block;
                text-align: center;
            }

            .invoice-box table tr.information table td {
                width: 100%;
                display: block;
                text-align: center;
            }
        }

        /** RTL **/
        .rtl {
            direction: rtl;
            font-family: "Poppins", sans-serif;
        }

        .rtl table {
            text-align: right;
        }

        .rtl table tr td:nth-child(2) {
            text-align: left;
        }
    </style>
</head>

<body>
    <div class="invoice-box">
    <div style="display:none;"></div>
        <table cellpadding="0" cellspacing="0">
            <tbody>
                <tr class="top">
                    <td colspan="4">
                        <table>
                            <tr>
                                <td class="title">

                                    ${data['job_no'].indexOf('ARC') > -1 ? 'Appliance Repair Center (ARC)' : `<img src=${settings['logo_url']}
                                    style="width:100%; max-width:260px;">`}

                                </td>

                                <td>
                                    <span style='font-size: 20px; font-weight: 600'>Form No: ${data['user_form_no']}</span><br>
                                    Job No: ${data['job_no']}<br>
                                    Created: ${moment(data['created_at'] || data['invoice_date']).format('DD/MM/YYYY')}<br>
                                </td>
                            </tr>
                        </table>
                    </td>
                </tr>

                <tr class="information">
                    <td colspan="4">
                        <table>
                            <tr>
                                <td>
                                <img src=images.png
                                    style="width:100%; max-width:260px;">
                                </td>

                                <td>
                                <h5>                                
                                    NATIONAL PROSECUTING AUTHORITY LAPTOP DECLARATION AGREEMENT FORM – (NPA OFFICIAL LAPTOP COMPUTERS )</h5>
                                </td>
                            </tr>
                        </table>
                    </td>
                </tr>

                <tr class="customer">
                    <td colspan="4">
                        <table>
                            <tr>
                                <td>
                                    LAPTOP USE AGREEMENT AND DECLARATION
                                </td>
                                <td>
                                </td>
                            </tr>
                        </table>
                    </td>
                </tr>

                <tr >
                    <td colspan="">
                        <table>
                            <tr>
                                <td>
                                    I, <strong><ins>${data['assignToUser']['first_name']}</ins></strong> <strong><ins>${data['assignToUser']['last_name']}</ins></strong> with Persal Number <strong><ins>${data['assignToUser']['user_id']}</ins> </strong>
                                    fully understand that as a user of this National Prosecuting Authority laptop that is my  responsibility to know and comply with all applicable security measures
                                    required for the protection of this laptop.
                                </td>
                                <td>
                                </td>
                            </tr>
                        </table>
                    </td>
                </tr>

                <tr>
                    <td colspan="4">
                        <table>
                            <tr>
                                <td>
                                    I hereby acknowledge the receipt of the laptop with listed details as follows:
                                </td>
                                <td>
                                </td>
                            </tr>
                        </table>
                    </td>
                </tr>

                <hr>
                <tr>
                    <td colspan="4">
                        <table>
                            <tr>
                                <td>
                                    New Laptop Information
                                </td>
                                <td>
                                </td>
                            </tr>
                        </table>
                    </td>
                </tr>

                <table border="1">
                <tr>
                    <th>IT BARCODE NUMBER</th>
                    <th>LAPTOP MAKE/MODEL</th>
                    <th>ITEM SERIAL NUMBER</th>
                </tr>
                <tr>
                    <td>${data['fullOldLaptopInfo']['barcode']}</td>
                    <td>${data['fullOldLaptopInfo']['brand']}</td>
                    <td>${data['fullOldLaptopInfo']['serial_number']}</td>
                </tr>
                </table>

                <br>
                <tr class="customer">
                    <td colspan="4">
                        <table>
                            <tr>
                                <td>
                                    As the user of the laptop I will be provided with a laptop card permit containing the correct details for my laptop and it is my sole responsibility to ensure the safekeeping of the laptop assigned under my name. In consideration of the right to use this laptop I shall abide by the following terms and conditions.                                </td>
                                <td>
                                </td>
                            </tr>
                        </table>
                    </td>
                </tr>

                <tr class="customer">
                    <td colspan="4">
                        <table>
                            <tr>
                                <td>
                                <strong>(1)</strong> I agree to keep this laptop under my custody and agree not to lend, loan, or otherwise provide it to any other person. I also agree to inform the Asset Management Official /Loss Control Officer of any loss or theft of the laptop. I further understand that NPA will seek to recover cost for repair or replacement of the laptop due to negligence on my part and / or failure to follow the Security Operating Procedures. I agree to fully cooperate with laptop reporting requirements and with property loss, theft or damage incident investigations.
                                <td>
                                </td>
                            </tr>
                        </table>
                    </td>
                </tr>

                 <tr class="customer">
                    <td colspan="4">
                        <table>
                            <tr>
                                <td>
                                <strong>(2)</strong> By signing the below I acknowledge and accept the responsibilities associated with my use of an official laptop as stated above and in the attached Security Operating Procedures.							
                        </table>
                    </td>
                </tr>

                <br>
                <table border="1">
                <tr>
                    <th>Printed Name & Surname</th>
                </tr>
                <tr>
                    <td>Laptop Custodian Signature</td>
                    <td> ____________________________</td>
                </tr>
                </table>
               
            </tbody>
        </table>
        
    </div>
</body>
</html>
        `
    )
}

export default invoice